import {Component} from "react";
import React from "react";
import PropTypes from 'prop-types';


class SearchForm extends Component {

    static propTypes = {
        /** Form title */
        title: PropTypes.string,
        /** value in serch field */
        value: PropTypes.string,
        /** placeholder for search input field */
        placeholder: PropTypes.string,
        name: PropTypes.string,
        className: PropTypes.string
    };

    static defaultProps = {
        title:"Sök",
        value:"",
        placeholder:"Sök..."
    };

    constructor(props){
        super(props);
        this.state= {
            value : this.props.value
        }
    }


    onClick(event){
        if (typeof(this.props.onClick)==="function"){
            this.props.onClick(event,this.state.value);
        } else if (typeof(this.props.onChange)==="function"){
            this.props.onChange(event);
        }
    }

    onChange(event){

        this.setState({
          value : event.target.value
        });
        if (typeof(this.props.onChange)==="function"){
            this.props.onChange(event);
        }

    }

    onKeyDown(event){

        //submitting on enter
      if(event.key === 'Enter'){
        if (typeof(this.props.onClick)==="function"){
            this.props.onClick(event,this.state.value);
        } else if (typeof(this.props.onChange)==="function"){
            this.props.onChange(event);
        }
        event.preventDefault();
      }

      //clearing on escape
      if (event.key==="Escape"){
        event.target.value="";
        event.preventDefault();
        this.setState({
          value : ""
        });
      }
    }



    render() {
        const {title, placeholder, name, className} = this.props;

            return (
                <div className={'box search-box ' + (className !== undefined || null ? className : '')}>
                    <div className='box-inner'>
                        {title.length>0 &&
                            <h2>{title}</h2>
                        }

                        <form>
                            <input
                                type='text'
                                placeholder={placeholder}
                                name={name}
                                onChange={(event)=>this.onChange(event)}
                                onKeyDown={(event)=>this.onKeyDown(event)}
                            />

                            <input
                              type="button"
                              name="submit"
                              className="searchgroup form-submit"
                              value="SÖK"
                              onClick={(event)=>this.onClick(event)}
                            />
                        </form>

                    </div>
                </div>
            );
    }
}

export default SearchForm;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/SearchForm.js